<template>
  <div class="mt-4 -mx-5 px-5 pt-4 border-t">
    <div class="flex flex-wrap justify-between items-center -mt-3 -ml-3">
      <div class="pt-3 pl-3 flex flex-wrap items-center">
        <Link
          v-if="abilities.delete"
          :href="route('cart.lines.discounts.destroy', [line, id])"
          preserve-scroll
          method="delete"
          class="flex w-8 h-8 -m-2 mr-2 text-gray-700 hover:text-gray-900"
          as="button"
        >
          <Icon type="cancel" class="m-auto" size="5" />
        </Link>
        <Code
          class="whitespace-nowrap mr-2"
          chunk="2"
          :value="code"
          :color="info.theme ?? 'default'"
        />
        <div class="whitespace-nowrap">
          <span class="text-gray-700 text-sm">
            {{ name }}
          </span>
          <template v-if="info.category">
            <span class="text-sm text-gray-700">,&nbsp;</span>
            <span class="text-sm" :class="color">
              {{ info.category }}
            </span>
          </template>
          <template v-if="info.text">
            <span class="text-sm text-gray-700">, {{ info.text }}</span>
          </template>
        </div>
      </div>
      <div class="pt-3 pl-3 flex-1 text-right">
        <strong class="text-lg" :class="color">
          {{ formatPrice(-applied) }}
        </strong>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
}
</script>

<script setup>
import Code from 'Web/Shared/Code.vue';
import Icon from 'Web/Shared/Icon.vue';
import Link from 'Web/Shared/Link.vue';
import formatPrice from '@/helpers/formatPrice';
import rescue from '@/helpers/rescue';
import { computed } from 'vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  line: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  code: {
    type: [Number, String],
    required: true,
  },
  info: {
    type: String,
    required: true,
  },
  applied: {
    type: [Number, String],
    required: true,
  },
  abilities: {
    type: Object,
    required: true,
  },
});

const info = computed(() => rescue(() => JSON.parse(props.info), {
  text: info,
}));

const color = computed(() => ({
  default: 'text-blue-500',
  pga:     'text-pga-500',
  pgb:     'text-pgb-500',
  pgc:     'text-pgc-500',
  pgd:     'text-pgd-500',
}[info.value.theme ?? 'default']));

</script>
